import { render, staticRenderFns } from "./DemForTrendMock.vue?vue&type=template&id=b4097e0e&"
import script from "./DemForTrendMock.vue?vue&type=script&lang=js&"
export * from "./DemForTrendMock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports